<template>
  <div class="flex flex-col justify-between">
    <div v-if="habits.length > 0">
      <header class="mint-header sticky top-0 justify-between">
        <category-dropdown :categories="categories" />
        <router-link :to="resolveCreateHabitLink()" class="flex items-center">
          <i class="material-icons mr-1 font-18px">add_circle_outline</i>
          <span>New Habit</span>
        </router-link>
      </header>

      <habits-table :habits="habitsArray" />

      <div class="h-62px"></div>
    </div>

    <div v-else class="h-screen flex flex-col justify-between">
      <div>
        <header class="mint-header justify-end">
          <router-link to="/create" class="flex items-center">
            <i class="material-icons mr-1 font-18px">add_circle_outline</i>
            <span> New Habit</span>
          </router-link>
        </header>

        <div
          class="flex justify-end mr-vw-1-3 text-gray-500 mt-4 items-baseline"
        >
          <p class="mr-1">Create your first habit</p>
          <i class="material-icons font-18px">call_made</i>
        </div>
      </div>

      <div class="text-gray-500 text-center">
        <p>"We first make our habits,<br />and then our habits make us."</p>
        <p class="mt-1 text-xs">- John Dryden (English Poet)</p>
      </div>

      <div class="h-102px"></div>
    </div>
  </div>
</template>

<script>
import habitModule from '@/store/modules/habit.module'
import categoryModule from '@/store/modules/category.module'
import userModule from '@/store/modules/user.module'
const CategoryDropdown = () => import('@/components/CategoryDropdown')
const HabitsTable = () => import('@/components/HabitsTable')
import constants from '@/store/constants'

const ACCOUNT_TYPES = constants.ACCOUNT_TYPES

export default {
  name: 'Habits',

  components: { CategoryDropdown, HabitsTable },

  data() {
    return {
      popupVisible: false
    }
  },

  computed: {
    categories: categoryModule.categories,
    habits: habitModule.habits,
    filteredHabits: habitModule.filteredHabits,
    reachedHabitsLimit: habitModule.reachedHabitsLimit,
    selectedCategory: categoryModule.selectedCategory,
    accountIsFree: userModule.accountIsFree,
    accountIsPro: userModule.accountIsPro,
    accountIsLife: userModule.accountIsPro,

    habitsArray() {
      if (this.selectedCategory === 'All Habits') {
        return this.habits
      }

      return this.filteredHabits
    }
  },

  methods: {
    resolveCreateHabitLink() {
      if (this.reachedHabitsLimit) {
        return { name: 'Prices', params: { from: 'Habits' } }
      }

      return 'create'
    }
  },

  mounted() {
    if (this.habits.length === 0) {
      habitModule.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.mint-header {
  display: flex;
  align-items: center;
  .a-icon {
    outline: none;
    text-decoration: none !important;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 18px;
    }
  }
}
.font-18px {
  font-size: 18px;
}
.h-102px {
  height: 102px;
}
.mr-vw-1-3 {
  margin-right: calc((100vw / 3) / 2);
}
</style>
